import styled from 'styled-components';
import { devices } from '../../../../../../juristec-ui/core/breakpoints';

export const MainContainer = styled.div`
  display: flex;
  flex-direction: column;
  height: 100%;
  width: 350px;
  @media ${devices.phoneL} {
    width: 100%;
  }
`;

export const InputWrapper = styled.div`
  display: grid;
  grid-template-columns: auto 150px;
  align-items: center;
  margin-bottom: 10px;
  gap: 5px;
  & > div {
    min-width: 0;
  }
  & > *:first-child:only-child {
    grid-column: span 2;
  }
  & .textAreaContainer {
    box-sizing: border-box;
    min-height: 100px;
  }
`;

export const IconFlipWrapper = styled.div`
  position: absolute;
  right: 0;
  transition: all 0.5s;
  & svg {
    fill: ${({ theme }) => theme.inputLabel};
  }
`;

export const KpiButton = styled.button`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: 100%;
  width: 100%;
  padding: 2px;
  max-height: 55px;
  background-color: transparent;
  border: 1px solid ${({ theme }) => theme.inputLabel};
  border-radius: 8px;
  cursor: pointer;
  position: relative;
  & > svg {
    aspect-ratio: 1 / 1;
    height: auto;
    display: flex;
    width: auto;
  }
  & > span {
    font-size: 9px;
    color: ${({ theme }) => theme.inputLabel};
  }
  &:hover {
    border-color: ${({ theme }) => theme.primary};
    & > span {
      color: ${({ theme }) => theme.primary};
    }
    ${IconFlipWrapper} {
      & svg {
        fill: ${({ theme }) => theme.primary};
      }
    }
  }
  &.kpi-selected {
    border-color: ${({ theme }) => theme.primary};
    background-color: ${({ theme }) => theme.primary}55;
    & > span {
      color: ${({ theme }) => theme.white};
    }
    ${IconFlipWrapper} {
      transform: rotate(180deg);
      & svg {
        fill: ${({ theme }) => theme.primary};
      }
    }
  }
`;

export const KpiPicker = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr 1fr 1fr;
  margin: 5px;
  grid-gap: 5px;
  & > button {
    width: 55px;
    height: 60px;
  }
`;

export const Label = styled.label`
  margin-left: auto;
  font-size: 0.85rem;
  color: ${({ theme }) => theme.grey};
  font-weight: bold;
`;
